// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BUiHF","comment":"styles_comment__2ydGV"};